"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        background: theme.palette.primary.main,
        color: theme.palette.common.white,
        padding: theme.spacing(2)
    }
}); });
var Alert = function (_a) {
    var children = _a.children;
    var classes = useStyles(styles_1.useTheme());
    return (React.createElement(core_1.Paper, { elevation: 0, className: classes.root },
        React.createElement(core_1.Typography, { component: "p" }, children)));
};
exports.default = Alert;
//# sourceMappingURL=Alert.js.map